import * as React from 'react';
import { Redirect } from 'react-router';

import { PageRoutes } from '~components/Root/constants';

const NotFoundPage: React.FunctionComponent = () => <Redirect to={PageRoutes.LANDING_PAGE} />;

export { NotFoundPage };
